import utilizationTarget from './actions/UtilizationTarget/texts.js';
import map from './Map/texts.js';
import screenExciterExpertAnalysis from './ScreenExciterExpertAnalysis/texts.js';
import screenResponse from './ScreenResponse/texts.js';
import screenStroke from './ScreenStroke/texts.js';
import visualisation from './Visualisation/texts.js';

export default {
  action: {
    utilizationTarget,
  },
  map,
  screenExciterExpertAnalysis,
  screenResponse,
  screenStroke,
  visualisation,
};
